if (!customElements.get('show-more')) {
  class ShowMore extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
      this.handleUpdateRef = this.handleUpdate.bind(this);
    }

    /**
     * @param {CustomEvent} event - event.detail.html as a document object
     */
    handleUpdate(event) {
      const showMore = event.detail.html.querySelector('show-more');
      if (!showMore) return this.remove();

      this.innerHTML = showMore.innerHTML;
    }

    handleClick(event) {
      event.preventDefault();

      const anchor = event.target.closest('a');
      if (!anchor) return;

      document.dispatchEvent(new CustomEvent('alexa:collection-grid-show-more',
        { detail: { url: anchor.getAttribute('href') } }
      ));
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickRef);
      document.removeEventListener('alexa:update-show-more', this.handleUpdateRef);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClickRef);
      document.addEventListener('alexa:update-show-more', this.handleUpdateRef);
    }
  }

  customElements.define('show-more', ShowMore);
}
